import axios from "axios";
import {
  HSUC_VUE_APP_AD_URL,
  HSUC_VUE_APP_YAF_URL,
  HSUC_VUE_APP_MKTGO_URL,
  HSUC_VUE_APP_MMC_URL,
  HSUC_VUE_APP_ADS_URL,
  HSUC_VUE_APP_ALB_URL,
  HSUC_VUE_APP_MESSAGE_URL,
  HSUC_VUE_APP_UC_URL

} from "./hsuc";
import jsonBig from "json-bigint";
import { getType, expandFormData } from "@/utils/utils.js";
const CancelToken = axios.CancelToken;
const pending = new Map();

class HttpRequest {
  constructor(url) {
    this.baseURL = process.env[`VUE_APP_${url}_URL`];
    this.withCredentials = true;
    this.timeout = 60000;
  }

  // 中间件
  middleRequest(options = {}) {
    const instance = axios.create();
    const config = {
      ...options,
      baseURL: this.baseURL,
      timeout: this.timeout,
      withCredentials: this.withCredentials,
    };
    // 如果请求参数 附带bigInt 将进行转换 备注：接口返回的int值超过最大
    if (options.bigInt) {
      config.transformResponse = [
        function (data) {
          try {
            // 如果转换成功则返回转换的数据结果
            return jsonBig.parse(data);
          } catch (err) {
            // 如果转换失败，则包装为统一数据格式并返回
            return {
              data,
            };
          }
        },
      ];
    }
    this.setInterceptors(instance, options.url);
    return instance(config);
  }

  // GET
  get(url, params, options = {}) {
    const GET = this.middleRequest({
      method: "get",
      url: url,
      params: params,
      responseType: options.isBolb ? "blob" : "",
      ...options,
      headers: { Authorization: localStorage.getItem('token') }
    });
    return GET;
  }

  // POST
  post(url, params, options = {}) {
    const POST = this.middleRequest({
      method: "post",
      url: url,
      data: params,
      ...options,
      headers: { Authorization: localStorage.getItem('token') },

    });
    return POST;
  }

  // PUT
  put(url, params, options = {}) {
    const PUT = this.middleRequest({
      method: "put",
      url: url,
      data: params,
      ...options,
      headers: { Authorization: localStorage.getItem('token') }
    });
    return PUT;
  }
  // 签名
  sign(config) {
    let HSUC_SIGN = null;
    switch (config.baseURL) {
      case process.env.VUE_APP_AD_URL:
        HSUC_SIGN = HSUC_VUE_APP_AD_URL;
        break;
      case process.env.VUE_APP_YAF_URL:
        HSUC_SIGN = HSUC_VUE_APP_YAF_URL;
        break;
      case process.env.VUE_APP_MKTGO_URL:
        HSUC_SIGN = HSUC_VUE_APP_MKTGO_URL;
        break;
      case process.env.VUE_APP_MMC_URL:
        HSUC_SIGN = HSUC_VUE_APP_MMC_URL;
        break;
      case process.env.VUE_APP_ALB_URL:
        HSUC_SIGN = HSUC_VUE_APP_ALB_URL;
        break;
        case process.env.VUE_APP_MESSAGE_URL:
          HSUC_SIGN = HSUC_VUE_APP_MESSAGE_URL;
          break;
      case process.env.VUE_APP_ADS_URL:
        HSUC_SIGN = HSUC_VUE_APP_ADS_URL;
        break;
      case process.env.VUE_APP_UC_URL:
        HSUC_SIGN = HSUC_VUE_APP_UC_URL;
        break;
      default:
        break;
    }
    let data =
      config.method === "get"
        ? config.params
        : getType(config.data) === "FormData"
        ? expandFormData(config.data)
        : config.data;
    //  data.menu_id = 'GLOBAL'
    if (config.method === "get") {
      config.params = HSUC_SIGN.sign(data, config.method);
    } else {
      config.data = HSUC_SIGN.sign(
        getType(config.data) === "FormData" ? config.data : data,
        config.method
      );
    }
  }
  // 撤销重复请求
  changePending(config) {
    this.sign(config);
    let requestKey = "";
    if (config.method === "post") {
      requestKey = config.data;
    }
    const url = [config.method, config.url, requestKey].join("&");
    config.cancelToken =
      config.cancelToken ||
      new CancelToken((cancel) => {
        if (pending.has(url)) {
          pending.set(url, cancel);
        } else if (pending.has(url)) {
          const cancel = pending.get(url);
          cancel(url);
          pending.delete(url);
        }
      });
  }

  // 清空清空
  clearPending() {
    for (const [url, cancel] of this.pending) {
      cancel(url);
    }
    this.pending.clear();
  }

  // 拦截器
  setInterceptors(instance) {
    this.requestInterceptors(instance);
    this.responseInterceptors(instance);
  }

  // 请求拦截器
  requestInterceptors(instance) {
    instance.interceptors.request.use(
      (config) => {
        this.changePending(config);
        return config;
      },
      () => {}
    );
  }

  // 响应拦截器
  responseInterceptors(instance) {
    instance.interceptors.response.use(
      (response) => {
        if (response.status === 200) {
          // 是否是返回的二进制的下载文件
          if (response.data instanceof Blob) {
            return Promise.resolve(response.data);
          }
          const res = response.data;
          if (+res.code === 0) {
            return Promise.resolve(response.data.data);
          } else if (
            [
              105046, 105401, 1190036, 1190037, 1190079, 1190041, 20103,
              1190035, 1190080,
            ].includes(res.code)
          ) {
            // 105046：试用期已过
            // 105401：登录失效
            localStorage.removeItem("token");
            window.location.href = window.location.origin + "/index";
            return Promise.reject(
              response.data.data.msg
                ? response.data.data.msg
                : response.data.msg
            );
          } else {
            const error = response.data.msg
              ? response.data.msg
              : response.data.data.msg;
            return Promise.reject(error);
          }
        } else {
          return Promise.reject(new Error("服务器开小差了，请刷新重试"));
        }
      },
      (error) => {
        console.log(error);
        const err = "服务器开小差了，请刷新重试";
        return Promise.reject(err);
      }
    );
  }
}

const HTTP_ALB = new HttpRequest("ALB");
const HTTP_MMC = new HttpRequest("MMC");
const HTTP_YAF = new HttpRequest("YAF");
const HTTP_MESSAGE = new HttpRequest("MESSAGE");
const HTTP_UC = new HttpRequest("UC");


export { HTTP_ALB, HTTP_MMC, HTTP_YAF,HTTP_MESSAGE,HTTP_UC };
